import { Link, useLocation } from 'react-router-dom';
import { navData } from './data';

/** Navigation component that dynamically generates navigation links based on the current page's path using data from navData. */
export const Navigation = () => {
  const location = useLocation();
  const [pageName] = location.pathname.split('/').slice(2, 4);
  const navItems = navData[`${pageName}Data`];

  if (!navItems || navItems.length === 0) {
    return null;
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            {navItems.map((item) => (
              <li className='nav-item' key={item.to}>
                <Link
                  className={
                    `nav-link text-active-primary me-6 ` +
                    (location.pathname === item.to && 'active')
                  }
                  to={item.to}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
